/**
 * Parse Jira-style time strings into minutes.
 * Accepts: "1h", "1.5h", "2h 30m", "90m", "90min", "45", "1h30m", "2.5"
 * Plain numbers are treated as hours (e.g. "2" = 120 minutes, "0.5" = 30 minutes).
 */
export const parseTime = (input) => {
  if (input === null || input === undefined || input === '') return null;

  const str = String(input).trim().toLowerCase();
  if (!str) return null;

  // Try "Xh Ym" or "XhYm" pattern
  const hm = str.match(/^(\d+(?:\.\d+)?)\s*h\s*(?:(\d+)\s*m(?:in)?)?$/);
  if (hm) {
    const hours = parseFloat(hm[1]);
    const mins = hm[2] ? parseInt(hm[2], 10) : 0;
    return Math.round(hours * 60 + mins);
  }

  // Try "Xm" or "Xmin" pattern
  const mOnly = str.match(/^(\d+(?:\.\d+)?)\s*m(?:in)?$/);
  if (mOnly) {
    return Math.round(parseFloat(mOnly[1]));
  }

  // Plain number — treat as hours
  const num = parseFloat(str);
  if (!isNaN(num)) {
    return Math.round(num * 60);
  }

  return null;
};

/**
 * Format minutes into a readable time string.
 * 0 → "—"
 * 30 → "30m"
 * 60 → "1h"
 * 90 → "1h 30m"
 * 120 → "2h"
 */
export const formatTime = (minutes) => {
  if (!minutes || minutes <= 0) return '—';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};

/**
 * Format minutes as a decimal hours string for display (e.g. 90 → "1.5h")
 */
export const formatHours = (minutes) => {
  if (!minutes || minutes <= 0) return '—';
  const hours = minutes / 60;
  return `${Number.isInteger(hours) ? hours : hours.toFixed(1)}h`;
};
